<template>
  <div class="newsItem">
    <PcNewsItem class="PC"/>
    <MDNewsItem class="MD"/>
  </div>
</template>

<script>
// 移动端
import MDNewsItem from './MDNewsItem.vue'
// pc端
import PcNewsItem from './PcNewsItem.vue'
export default {
  name: 'newsMain',
  components: {
    PcNewsItem,
    MDNewsItem
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsItem{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsItem{
    .MD{
      display: none;
    }
  }
}
</style>
